import { CandidateStatus } from 'generated-graphql/types';

export const requirementConditionStatusOptions = [
  CandidateStatus.Rejected,
  CandidateStatus.NotProgressing,
  CandidateStatus.ShortListed,
  CandidateStatus.Review,
  CandidateStatus.InterviewStage_1,
  CandidateStatus.InterviewStage_2,
  CandidateStatus.Offer
];
